import { gql, useQuery } from '@apollo/client';

export const GET_DOCUMENT_IMPORTER__BY_ID = gql`
  query getDocumentImporterTemplate($id: String!) {
    getDocumentImporter(id: $id) {
      _id
      title
      companyId
      createdBy
      totalImportedDocuments
      importedDocuments {
        fileId
        fileName
        memberId
      }
    }
  }
`;

export const useGetDocumentImporter = (id?: string) => {
  const { data, loading } = useQuery(GET_DOCUMENT_IMPORTER__BY_ID, {
    variables: { id },
    skip: !id,
  });

  const documentImporter = data?.getDocumentImporter || {};

  return { documentImporter, loading };
};
